"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openSecurityModal = exports.openModal = exports.openDenounceModal = exports.openDeleteModal = exports.openButtonActionModal = exports.closeModal = void 0;
var _types = require("./types");
// ====================================================================
// Typed actions
// ====================================================================

var open = function open(content, type, padding, isFullScreen) {
  return {
    type: _types.MODAL.OPEN,
    value: {
      isVisible: true,
      content: content,
      type: type,
      padding: padding,
      isFullScreen: isFullScreen
    }
  };
};
var close = function close() {
  return {
    type: _types.MODAL.CLOSE,
    value: {
      isVisible: false
    }
  };
};

// ====================================================================
// Functions actions
// ====================================================================

var openModal = exports.openModal = function openModal(content, type, padding) {
  var isFullScreen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch) {
    dispatch(open(content, type, padding, isFullScreen));
  };
};
var closeModal = exports.closeModal = function closeModal() {
  return function (dispatch) {
    dispatch(close());
  };
};

// ====================================================================
// Specific actions
// ====================================================================

var openSecurityModal = exports.openSecurityModal = function openSecurityModal(content, amISeller, tipOptions) {
  return function (dispatch, _, _ref) {
    var Lurker = _ref.Lurker;
    Lurker.viewSecurityBox(amISeller, tipOptions);
    dispatch(openModal(content, _types.MODAL_TYPE.RISE));
  };
};
var openDenounceModal = exports.openDenounceModal = function openDenounceModal(content, isFullScreen) {
  return function (dispatch) {
    dispatch(openModal(content, _types.MODAL_TYPE.RISE, undefined, isFullScreen));
  };
};
var openDeleteModal = exports.openDeleteModal = function openDeleteModal(content) {
  return function (dispatch) {
    dispatch(openModal(content));
  };
};
var openButtonActionModal = exports.openButtonActionModal = function openButtonActionModal(content) {
  return function (dispatch) {
    dispatch(openModal(content));
  };
};